import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { DetectEnvironment } from "../../../EnvironmentSettings";

const TransactionCompleted = (props) => {
    const location = useLocation();
    const { totalAmount } = location.state || {};
    return (
        <div>
            <div className="welcome-wrapper">
                <div className="row" >
                    <div className="col-lg-9">
                        <img className="welcome-page-logo" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="logo" />
                        <div className="row justify-content-lg-center welcome-pad">
                            <div className="col-lg-9">
                                <div className="signup-form-wrapper trasaction-complete">
                                    <i className="fa fa-regular fa-circle-check tickmark"></i>

                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="la-para">
                                                You have successfully subscribed to LiveAdims live chat.<br /> Your credit card has been charged for the following amount
                                            </div>
                                            <div className="la-heading">
                                                {totalAmount}
                                            </div>
                                            <div className="la-para">
                                                Please wait while we process your order. Check your email for License Key to login to LiveAdmins.
                                            </div>
                                            <div className="la-para">
                                                This page will automatically refresh in 60 seconds. <a href="https://testing.thelivechatsoftware.com/#/login">Click here</a> <br />If it doesn't refresh automatically.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="right-bar success-right-bar col-lg-3" >
                    </div>
                </div>
            </div>

        </div>

    )
}
export default TransactionCompleted;